import React, { useState, useEffect } from "react";

import { getAllData, addData, deleteIdData } from "../../../lib/progressCheck";
import { getDataWithType } from "../../../lib/parameters";

export default function AdminProgressCheck() {
  const [type, setType] = useState("Awards");
  const [parameters, setParameters] = useState([]);
  const [showmessage, setShowMessage] = useState(false);
  const [progressChecks, setpProgressChecks] = useState([]);
  const [order, setOrder] = useState(0);
  const [score, setScore] = useState(1);
  const [description, setDescription] = useState("");

  const fetchParameters = async () => {
    const params = await getDataWithType("PROGRESSCHECK");
    setParameters(params);
  };

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      getProgressChecks();
    }
  };

  const getProgressChecks = async () => {
    //setShowMessage(false);
    const prgsChcks = await getAllData();
    setpProgressChecks(prgsChcks);
  };

  useEffect(() => {
    //fetchParameters();
    getProgressChecks();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await addData({
      type,
      order,
      description,
      score
    });

    setType("Awards");
    setDescription("");
    setOrder(0);
    setShowMessage(true);
    getProgressChecks();
    setScore(1);
  };

  return (
    <div className="col-xl-12 col-md-12">
      {/* <div className="settings-widget profile-details p-2"> */}
      <div className="settings-inner-blk p-2">
        <div className="p-2">
          <h3>Progress Checks</h3>
          {showmessage && (
            <div
              className="alert alert-success alert-dismissible fade show"
              role="alert"
            >
              <strong>Updated!</strong> your Settings.
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
              ></button>
            </div>
          )}
          <div className="new-address">
            <div className="row">
              <div className="col"></div>
            </div>
          </div>
        </div>
        <div className="checkout-form personal-address add-course-info ">
          <form method="post" onSubmit={handleSubmit}>
            <div className="row mx-auto">
              <div className="col-9">
              <label className="form-control-label">Parameter</label>
                <select
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  className="form-control mb-2"
                  required
                >
                    <option value={"Awards"}>{"Awards"}</option>
                    <option value={"Activities"}>{"Activities"}</option>
                </select>
              </div>
              <div className="col-9">
                <div className="form-group">
                  <label className="form-control-label">Description</label>
                  <input
                    type="text"
                    name="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="form-control"
                    placeholder="Enter Description"
                    required
                  />
                </div>
              </div>

              <div className="col-9">
                <div className="form-group">
                  <label className="form-control-label">Order</label>
                  <input
                    type="number"
                    name="order"
                    value={order}
                    onChange={(e) => setOrder(e.target.value)}
                    className="form-control"
                    placeholder="Order"
                  />
                </div>
              </div>
              <div className="col-9">
              <label className="form-control-label">Score</label>
                <select
                  value={score}
                  onChange={(e) => setScore(e.target.value)}
                  className="form-control mb-2"
                  required
                >
                    <option value={1}>{"1"}</option>
                    <option value={2}>{"2"}</option>
                    <option value={3}>{"3"}</option>
                    <option value={4}>{"4"}</option>
                </select>
              </div>
              <div className="col-9"></div>
              <div className="update-profile d-flex justify-content-between">
                <button type="submit" className="btn btn-primary">
                  Add Progress Check
                </button>
              </div>
            </div>
          </form>
        </div>
        </div>
        <div className="settings-inner-blk p-2">
          <div className="p-2">
            <h3>Progress Checks</h3>
            <div className="new-address">
              <div className="row">
                <div className="col"></div>
              </div>
            </div>
          </div>
          <div className="comman-space pb-0">
            <div className="settings-invoice-blk table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Order</th>
                    <th>Description</th>
                    <th>Type</th>
                    <th>Score</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {progressChecks.map(function (data) {
                    return (
                      <tr key={data.id}>
                        <td>{data.order}</td>
                        <td>{data.description}</td>
                        <td>{data.type}</td>
                        <td>{data.score}</td>
                        <td>
                          <div className="profile-share d-flex align-items-center justify-content-end">
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDelete(data.id)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      {/* </div> */}
    </div>
  );
}
